<template>
    <div class="g-content g-autofixheight order-unpack">
        <!-- 派单[[ -->
        <div
            class="g-popup g-popup-transparent js-popup-confirm-distribute"
            v-if="assignOrderDialog.show"
        >
            <div class="popup-con confirm-popup confirm-distribute">
                <div class="popup-close js-close-view">
                    <i class="ico ico-close" @click="assignOrderDialog.show=false"></i>
                </div>
                <h5 class="popup-title">派单确认</h5>
                <p class="confirm-content">派单后，此订单将无法新增及编辑作者订单。是否继续派单？</p>
                <ul class="distribute-list g-scrollbar">
                    <li
                        class="distribute-item"
                        v-for="author in assignOrderDialog.authorList"
                        :key="author"
                    >
                        <span class="item-title">订单派给</span>
                        <div class="distribute-detail">
                            {{ author.userName }}
                            <span class="order-no">{{ author.object_name }}</span>
                        </div>
                    </li>
                </ul>
                <div class="btn-group f-clearfix">
                    <a class="g-btn confirm-btn" href="javascript:;" @click="assignOrder">派单</a>
                    <a
                        class="g-btn cancell f-fr"
                        href="javascript:;"
                        @click="assignOrderDialog.show=false"
                    >取消</a>
                </div>
            </div>
        </div>
        <!-- 派单]] -->
        <!-- 7.30添加 -->
        <!-- 新建作者订单 [[ -->
        <div
            class="g-popup author-order-popup js-author-order"
            style="z-index: 100"
            v-if="authorOrderDialog.show"
            v-loading="saveAuthorLoading"
        >
            <div class="popup-con">
                <div class="popup-close js-close-view">
                    <i class="ico ico-close" @click="cancelSubmitAuthorOrder"></i>
                </div>
                <h5 class="popup-title">作者订单</h5>
                <div class="author-order-con">
                    <div class="author-order-item order-name">
                        <p class="title">订单名</p>
                        <input
                            class="author-order-input g-input"
                            type="text"
                            placeholder="请输入作者订单名称"
                            v-model="aOrderParams.orderName"
                        >
                    </div>
                    <div class="author-order-item">
                        <p class="title unpack-time">时间</p>
                        <div class="g-select js-selector2">
                            <div class="set">
                                <el-date-picker
                                    v-model="aOrderParams.dateVal"
                                    type="daterange"
                                    :picker-options="authorOderPickerOptions"
                                    range-separator="至"
                                    :start-placeholder="defaultsDate"
                                    :end-placeholder="defaulteDate"
                                    value-format="yyyy-MM-dd"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                ></el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="author-order-item author-order-type">
                        <p class="title">图文</p>
                        <input
                            class="author-order-input g-input"
                            type="text"
                            placeholder="图文数量"
                            v-model="aOrderParams.textNum"
                        >
                        <p class="title">视频</p>
                        <input
                            class="author-order-input g-input"
                            type="text"
                            placeholder="视频数量"
                            v-model="aOrderParams.videoNum"
                        >
                    </div>
                    <div class="author-order-item author-order-type">
                        <p class="title">小说</p>
                        <input
                            class="author-order-input g-input"
                            type="text"
                            placeholder="小说数量"
                            v-model="aOrderParams.novelNum"
                        >
                        <p class="title">漫画</p>
                        <input
                            class="author-order-input g-input"
                            type="text"
                            placeholder="漫画数量"
                            v-model="aOrderParams.paintingNum"
                        >
                    </div>
                    <div class="author-order-item">
                        <p class="title">预期金额</p>
                        <div class="budget f-inlineblock-top">
                            <p class="budget-num f-inlineblock-top">
                                &yen;
                                <span class="budget-num-con f-hide-col-1">{{ getBudget }}</span>
                            </p>
                            <div class="budget-icon f-inlineblock-top">
                                <span class="ico ico-question-mark"></span>
                                <div class="budget-con">
                                    <span class="ico ico-triangle"></span>
                                    <div class="budget-con-text">
                                        <p class="text-con">
                                            图文
                                            <span class="text-color">&yen;150</span>/篇
                                        </p>
                                        <p class="text-con">
                                            视频
                                            <span class="text-color">&yen;400</span>/篇
                                        </p>
                                        <p class="text-con">
                                            小说
                                            <span class="text-color">&yen;250</span>/篇
                                        </p>
                                        <p class="text-con">
                                            漫画
                                            <span class="text-color">&yen;400</span>/篇
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--<span class="error-prompt">预算总额大于剩余预算额</span>-->
                    </div>
                    <div class="author-order-item select-option-item">
                        <div class="author-order-select">
                            <label class="tab-item" @click="aOrderParams.authorType = 1">
                                <i
                                    class="ico ico-choose"
                                    :class="{'ico-choose-pre': aOrderParams.authorType == 1}"
                                ></i>团长
                            </label>
                            <label class="tab-item" @click="aOrderParams.authorType = 2">
                                <i
                                    class="ico ico-choose"
                                    :class="{'ico-choose-pre': aOrderParams.authorType == 2}"
                                ></i>个人作者
                            </label>
                        </div>
                        <div class="change-tabs">
                            <div
                                class="change-tabs-con team-change"
                                v-if="aOrderParams.authorType == 1"
                            >
                                <div class="select-team f-clearfix">
                                    <el-select
                                        style="width: 50%"
                                        v-model="aOrderParams.teamId"
                                        filterable
                                        placeholder="请选择团队"
                                    >
                                        <el-option
                                            v-for="team in teamList"
                                            :key="team.authorTeamName"
                                            :label="team.authorTeamName"
                                            :value="team.id"
                                        ></el-option>
                                    </el-select>
                                    <p class="team-change-qq f-inlineblock-top f-fr">
                                        团长QQ
                                        <span class="qq-con">{{ getTeamLeader }}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="change-tabs-con person-change" v-else>
                                <p class="title">作者QQ</p>
                                <div class="type-contain f-inlineblock-top">
                                    <input
                                        class="type-contain-input g-input"
                                        type="text"
                                        placeholder="请输入作者QQ"
                                        v-model="aOrderParams.authorQQ"
                                    >
                                    <span
                                        v-if="aOrderParams.authorQQ.length"
                                        class="ico ico-lose"
                                        @click="aOrderParams.authorQQ = ''"
                                    ></span>
                                </div>
                                <!--<span class="error-prompt">该QQ未注册TGL</span>-->
                            </div>
                        </div>
                    </div>
                    <div class="author-order-item">
                        <p class="title">说明</p>
                        <textarea
                            class="show-input"
                            rows
                            cols
                            placeholder="请输入产出和周期说明"
                            v-model="aOrderParams.cycleExplain"
                        ></textarea>
                    </div>
                </div>
                <div class="author-order-btn">
                    <a
                        class="g-btn preserve-btn js-order-preserve"
                        href="javascript:;"
                        @click="submitAuthorOrder"
                    >保存</a>
                    <a class="g-btn" href="javascript:;" @click="cancelSubmitAuthorOrder">取消</a>
                </div>
            </div>
        </div>
        <!-- 新建作者订单 ]] -->

        <div class="order-message" v-loading="saveSupplierLoading">
            <h5 class="order-unpack-tit">
                <span class="ico ico-step1"></span>
                <p class="tit-con">拆单</p>
                <!-- 拆单编辑保存后显示 -->
                <a
                    class="g-btn order-unpack-add-btn js-chaidan-edit-btn"
                    href="javascript:;"
                    v-if="showSupplierOrderInfo"
                    @click="editSupplierOrder"
                >编辑</a>
            </h5>
            <div class="order-message-con f-clearfix">
                <img
                    class="order-detail-header f-fl"
                    :src="demandInfo.logoUrl"
                    width="80"
                    height="80"
                >
                <div v-if="!showSupplierOrderInfo">
                    <!-- 拆单-编辑中 [[ -->
                    <div class="order-input-contain order-message-in-edit f-fr">
                        <input
                            class="order-name"
                            type="text"
                            placeholder="请输入拆单名称（30个字以内）"
                            v-model="sOrderParams.orderName"
                        >
                        <div class="order-date">
                            <p class="title unpack-time">时 间</p>
                            <div class="g-select js-selector1">
                                <div class="set">
                                    <el-date-picker
                                        v-model="sOrderParams.dateVal"
                                        type="daterange"
                                        :picker-options="pickerOptions"
                                        range-separator="至"
                                        :start-placeholder="defaultsDate"
                                        :end-placeholder="defaulteDate"
                                        value-format="yyyy-MM-dd"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                    ></el-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="show">
                            <p class="title">说明</p>
                            <textarea
                                class="show-input"
                                rows
                                cols
                                placeholder="请输入产出和周期说明"
                                v-model="sOrderParams.cycleExplain"
                            ></textarea>
                            <div class="text-num">{{sOrderParams.cycleExplain.length || 0 }}/100</div>
                        </div>
                        <div class="order-message-btn">
                            <a
                                class="g-btn preserve-btn js-chaidan-preserve"
                                href="javascript:;"
                                @click="saveSupplierOrder"
                            >保存</a>
                            <a class="g-btn" href="javascript:;" @click="cancelSaveSupplierOrder">取消</a>
                        </div>
                    </div>
                    <!-- 拆单-编辑中 ]] -->
                </div>

                <!-- 拆单编辑保存后 对应的内容-->
                <!-- 拆单-编辑后 [[ -->
                <div
                    class="order-input-contain order-message-after-edit f-fr"
                    v-if="showSupplierOrderInfo"
                >
                    <p class="order-input-name">{{ supplierOrderInfo.order_name }}</p>
                    <p class="order-input-time">
                        {{ supplierOrderInfo.start_time ? supplierOrderInfo.start_time.substr(0, 10) : '' }}
                        ~
                        {{ supplierOrderInfo.end_time ? supplierOrderInfo.end_time.substr(0, 10) : '' }}
                    </p>
                    <p class="order-input-describe">{{ supplierOrderInfo.cycle_explain }}</p>
                </div>
                <!-- 拆单-编辑后 ]] -->
            </div>
        </div>

        <div class="commit-task g-autofixheight">
            <!-- 未编辑拆单 [[ -->
            <div class="not-created" v-if="!sOrderParams.orderId">
                <h5 class="order-unpack-tit">
                    <span class="ico ico-step2"></span>
                    <p class="tit-con">新建作者订单</p>
                    <a class="g-btn order-unpack-add-btn" href="javascript:;">添加作者订单</a>
                </h5>
                <p class="created-con">拆单完成，点击“添加作者订单”设置详情</p>
            </div>
            <!-- 未编辑拆单 ]] -->

            <!-- 拆单编辑保存后显示 -->
            <!-- 已编辑拆单 [[ -->
            <div class="already-created" style="display: block" v-else>
                <h5 class="order-unpack-tit">
                    <span class="ico ico-step2"></span>
                    <p class="tit-con">新建作者订单</p>
                    <a
                        class="g-btn order-unpack-add-btn js-add-btn"
                        href="javascript:;"
                        @click="addAuthorOrder"
                    >添加作者订单</a>
                </h5>
                <p class="created-con already-created-con" v-if="authorOrderList.length===0">
                    拆单完成，点击
                    <span class="created-con-text">“添加作者订单”</span>设置详情
                </p>
                <div class="freelance-list" v-if="authorOrderList.length">
                    <ul class="freelance-list-con">
                        <li class="list" v-for="authorOrder in authorOrderList">
                            <div class="file-con f-clearfix">
                                <div class="file-intro f-fl">
                                    <span class="file-name f-hide-col-1">{{ authorOrder.order_name}}</span>
                                    <div class="type-detail-con">
                                        <div class="type-item">
                                            漫画：
                                            <span class="type-num">{{ authorOrder.cartoonPre}}</span>
                                        </div>
                                        <div class="type-item">
                                            小说：
                                            <span class="type-num">{{ authorOrder.novelPre}}</span>
                                        </div>
                                    </div>
                                    <div class="type-detal-con">
                                        <div class="type-item">
                                            视频：
                                            <span class="type-num">{{ authorOrder.videoPre}}</span>
                                        </div>
                                        <div class="type-item">
                                            图文：
                                            <span class="type-num">{{ authorOrder.articlesPre}}</span>
                                        </div>
                                    </div>
                                    <div
                                        class="date"
                                    >{{ authorOrder.start_time }}－{{ authorOrder.end_time }}</div>
                                </div>
                                <div class="budget f-fl">
                                    <div class="type-item f-hide-col-1">
                                        {{ authorOrder.userName }}{{ authorOrder.author_type === 1 ? '（团长）' : '（作者）'}}
                                        <span
                                            class="type-all"
                                        >{{ authorOrder.object_name }}</span>
                                    </div>
                                    <div class="type-item f-hide-col-1">
                                        含税总预算
                                        <span
                                            class="type-all"
                                        >{{ $common.toThousandsFilter(authorOrder.totalBudgetTax)}}</span>
                                    </div>
                                    <div class="switch">
                                        <span class="switch-explain-tit">说明</span>
                                        <div class="ico ico-question-mark">
                                            <p class="switch-explain-con">
                                                <span class="ico ico-triangle"></span>
                                                <span
                                                    class="text-con"
                                                >{{ authorOrder.cycle_explain }}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="operation f-fr">
                                    <p class="btn">
                                        <a
                                            class="g-btn"
                                            href="javascript:;"
                                            @click="editAuthorOrder(authorOrder)"
                                        >编辑</a>
                                        <a
                                            class="g-btn js-del-order"
                                            href="javascript:;"
                                            @click="deleteAuthorOrder(authorOrder)"
                                        >删除</a>
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <!-- 分页[[ -->
                    <pagination
                        v-if="paginationConf.total >0"
                        :total="paginationConf.total"
                        :page-size="paginationConf.pageSize"
                        @change="pageChange"
                        ref="pager"
                    ></pagination>
                    <!-- 分页]] -->
                </div>
            </div>
            <div class="footer-bar">
                <div class="footer-bar-btn">
                    <div class="g-bottom-btn btn-group">
                        <a class="button f-fr" href="javascript:;" @click="goBack">返回</a>
                        <!--选中状态  为a标签添加类 active -->
                        <a
                            class="button f-fr"
                            href="javascript:;"
                            v-if="authorOrderList.length"
                            @click="showAssignDialog"
                        >派单</a>
                        <!--<a class="button active f-fr" href="order-detail-supplier.html">保存</a>-->
                    </div>
                </div>
            </div>
            <!-- 已编辑拆单 ]] -->
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/order/order_unpack.scss";
.confirm-distribute .confirm-content {
    width: 290px;
    padding: 30px 0;
}

.confirm-distribute .distribute-list {
    width: 400px;
    height: 250px;
    padding-left: 70px;
}
.confirm-distribute .distribute-list .distribute-item {
    padding-bottom: 20px;
    font-size: 0;
}
.confirm-distribute .distribute-list .distribute-item .item-title {
    font-size: 14px;
    color: #666666;
    line-height: 20px;
}
.confirm-distribute .distribute-list .distribute-item .distribute-detail {
    display: inline-block;
    padding-left: 30px;
    font-size: 18px;
    line-height: 25px;
}
.confirm-distribute
    .distribute-list
    .distribute-item
    .distribute-detail
    .order-no {
    padding-left: 10px;
}

.confirm-distribute .btn-group {
    padding-top: 40px;
}
</style>
<script>
import pagination from "Components/v4/pagination/pagination_v4";

import {
    SaveAuthorOrder,
    SaveSupplierOrder,
    SupplierOrderInfo,
    SupplierAuthorOrderList,
    DeleteAuthorOrder,
    TeamAll,
    AssignSupplierOrderInfo,
    AssignSupplierOrder,
    SupplierDemandInfo
} from "Services/getData.js";
export default {
    name: "order_unpack.vue", // UGC 内容拆单页
    data() {
        return {
            // 供应商订单相关参数
            sOrderParams: {
                demandId: "",
                orderId: "",
                orderName: "",
                startTime: "",
                endTime: "",
                cycleExplain: "",
                dateVal: []
            },
            // 新建或保存作者订单
            aOrderParams: {
                supplierOrderId: "",
                authorOrderId: "",
                orderName: "",
                startTime: "",
                endTime: "",
                cycleExplain: "",
                textNum: "",
                videoNum: "",
                novelNum: "",
                paintingNum: "",
                authorType: 2,
                teamId: "",
                authorQQ: "",

                dateVal: [],
                budget: ""
            },
            params: {
                supplierOrderId: "",
                authorQq: "",
                authorOrderName: "",
                pageSize: "",
                pageIndex: ""
            },
            paginationConf: {
                total: 0,
                pageSize: 10
            },
            demandInfo: {
                id: "",
                logoUrl: "",
                start_time: "",
                end_time: ""
            },
            authorOrderList: [],
            supplierOrderInfo: {},
            dateVal: [],
            defaultsDate: "",
            defaulteDate: "",
            defaultDate: [],
            showSupplierOrderInfo: false,
            authorOrderDialog: {
                show: false
            },
            teamList: [],
            assignOrderDialog: {
                show: false,
                supplierOrderId: "",
                authorList: []
            },
            saveAuthorLoading: false,
            saveSupplierLoading: false
        };
    },
    components: {
        pagination
    },
    created() {
        let { demandId, supplierOrderId } = this.$route.query;
        if (!demandId && !supplierOrderId) {
            this.$alert("参数错误~");
            return this.$router.history.push({
                name: "v4-order-supplier"
            });
        }
        if (supplierOrderId) {
            this.sOrderParams.orderId = supplierOrderId;
            this.aOrderParams.supplierOrderId = supplierOrderId;
            this.params.supplierOrderId = supplierOrderId;
            this.getSupplierOrderInfo();
            this.getAuthorOrderList();
        } else {
            this.sOrderParams.demandId = demandId;
            this.getDemandInfo();
        }
    },
    mounted() {
        this.getAllTeams();
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        // '$route': 'fetchData'
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        saveSupplierOrder() {
            let {
                demandId,
                orderName,
                cycleExplain,
                dateVal
            } = this.sOrderParams;
            if (!demandId) {
                this.$alert("参数错误~");
                setTimeout(this.$router.go(-1), 2000);
                return false;
            }
            if (orderName.length === 0 || orderName.length > 30) {
                this.$alert("供应商订单名称必须在1-30个字符~");
                return false;
            }
            if (orderName.length === 0 || orderName.length > 30) {
                this.$alert("供应商订单名称必须在1-30个字符~");
                return false;
            }
            if (cycleExplain.length === 0 || cycleExplain.length > 100) {
                this.$alert("供应商订单产出和周期说明必须在1-100个字符~");
                return false;
            }
            if (!dateVal.length) {
                this.$alert("选择供应商订单时间~");
                return false;
            }
            this.sOrderParams.startTime = dateVal[0].substr(0, 10);
            this.sOrderParams.endTime = dateVal[1].substr(0, 10);
            this.doSaveSupplierOrder();
        },
        editSupplierOrder() {
            this.showSupplierOrderInfo = false;
            let {
                cycle_explain,
                start_time,
                end_time,
                order_name,
                game_logo,
                demand_id
            } = this.supplierOrderInfo;
            this.sOrderParams.orderName = order_name;
            this.sOrderParams.cycleExplain = cycle_explain;
            this.sOrderParams.dateVal = [start_time, end_time];
            this.sOrderParams.startTime = start_time;
            this.sOrderParams.endTime = end_time;
            this.sOrderParams.demandId = demand_id;
            this.$nextTick(() => {
                this.demandInfo.logoUrl = game_logo;
            });
        },
        async getDemandInfo() {
            let res = await SupplierDemandInfo({
                demandId: this.sOrderParams.demandId
            });
            if (res.status === 200 && res.data.code == 0) {
                let data = res.data;
                if (data.code == 0) {
                    this.demandInfo = data.data;
                }
            }
        },
        async assignOrder() {
            let response = await AssignSupplierOrder({
                supplierOrderId: this.sOrderParams.orderId
            });
            let result = response.data;
            if (result.code === 0) {
                this.assignOrderDialog.show = false;
                this.$alert("操作成功");
                // 去供应商订单详情页
                this.$router.history.push({
                    name: "v4-order-supplier-detail-ugc",
                    query: {
                        id: this.sOrderParams.orderId
                    }
                });
            }
        },
        cancelSaveSupplierOrder() {
            if (!this.sOrderParams.orderId) {
                return this.goBack();
            }
            this.showSupplierOrderInfo = true;
        },
        addAuthorOrder() {
            let { supplierOrderId } = this.aOrderParams;
            this.aOrderParams = {
                supplierOrderId: supplierOrderId,
                authorOrderId: "",
                orderName: "",
                startTime: "",
                endTime: "",
                cycleExplain: "",
                textNum: "",
                videoNum: "",
                novelNum: "",
                paintingNum: "",
                authorType: 2,
                teamId: "",
                authorQQ: "",
                dateVal: [],
                budget: ""
            };
            this.authorOrderDialog.show = true;
        },
        cancelSubmitAuthorOrder() {
            this.authorOrderDialog.show = false;
        },
        showAssignDialog() {
            this.getAssignSupplierOrderInfo(this.supplierOrderInfo);
        },
        submitAuthorOrder() {
            let {
                authorType,
                orderName,
                teamId,
                authorQQ,
                cycleExplain,
                textNum,
                videoNum,
                novelNum,
                paintingNum
            } = this.aOrderParams;
            if (!orderName) {
                this.$alert("请填写作者订单名称~");
                return false;
            }
            if (!(textNum && videoNum && novelNum && paintingNum)) {
                this.$alert("请填写内容数量~");
                return false;
            }
            if (authorType === 1 && !teamId) {
                this.$alert("请选择团队或填写作者QQ~");
                return false;
            }
            if (!orderName) {
                this.$alert("请填写作者订单名称~");
                return false;
            }
            if (!cycleExplain) {
                this.$alert("请填写作者订单说明~");
                return false;
            }
            let param = this.aOrderParams;
            if (param.authorType == 2) {
                if (!authorQQ) {
                    this.$alert("请填写作者QQ~");
                    return false;
                }
                param.teamId = "";
            }
            if (param.dateVal.length < 2) {
                this.$alert("请填写订单时间~");
                return false;
            }
            param.startTime = param.dateVal[0];
            param.endTime = param.dateVal[1];
            this.saveAuthorOrder(param);
        },
        editAuthorOrder(authorOrder) {
            let {
                order_name,
                start_time,
                end_time,
                cycle_explain,
                id,
                object_name,
                author_type,
                novelPre,
                articlesPre,
                cartoonPre,
                videoPre,
                isReceiver,
                object_id
            } = authorOrder;
            this.aOrderParams.authorOrderId = id;
            this.aOrderParams.orderName = order_name;
            this.aOrderParams.dateVal = [start_time, end_time];
            this.aOrderParams.startTime = start_time;
            this.aOrderParams.endTime = end_time;
            this.aOrderParams.textNum = articlesPre;
            this.aOrderParams.videoNum = videoPre;
            this.aOrderParams.paintingNum = cartoonPre;
            this.aOrderParams.novelNum = novelPre;
            this.aOrderParams.orderName = order_name;
            this.aOrderParams.cycleExplain = cycle_explain;
            if (author_type == 1) {
                // 团长
                this.aOrderParams.authorType = 1;
                this.aOrderParams.teamId = object_id;
            } else {
                this.aOrderParams.teamId = "";
                this.aOrderParams.authorType = 2;
                this.aOrderParams.authorQQ = object_name;
            }
            this.authorOrderDialog.show = true;
        },
        async saveAuthorOrder(param) {
            if (this.saveAuthorLoading) {
                this.$alert("操作频繁~");
                return false;
            }
            this.saveAuthorLoading = true;
            let response = await SaveAuthorOrder(param);
            this.saveAuthorLoading = false;
            let result = response.data;
            if (result.code === 0) {
                this.$alert("操作成功");
                this.authorOrderDialog.show = false;
                this.getAuthorOrderList();
            }
        },
        async getAssignSupplierOrderInfo() {
            let response = await AssignSupplierOrderInfo({
                supplierOrderId: this.supplierOrderInfo.id
            });
            let result = response.data;
            if (result.code === 0) {
                this.assignOrderDialog.show = true;
                this.assignOrderDialog.authorList = result.data;
            }
        },
        async deleteAuthorOrder(order) {
            let response = await DeleteAuthorOrder({
                orderId: order.id
            });
            let result = response.data;
            if (result.code === 0) {
                this.$alert("操作成功");
                this.getAuthorOrderList();
            }
        },
        async getAuthorOrderList() {
            let param = this.params;
            let response = await SupplierAuthorOrderList(param);
            let result = response.data;
            if (result.code === 0) {
                this.authorOrderList = result.data.data.map(order => {
                    order.showDesc = false;
                    return order;
                });
                this.paginationConf.total = result.data.count;
            }
        },
        async getAllTeams() {
            let response = await TeamAll();
            let result = response.data;
            if (result.code === 0) {
                this.teamList = result.data;
            }
        },
        async doSaveSupplierOrder() {
            if (this.saveSupplierLoading) {
                this.$alert("操作频繁~");
                return false;
            }
            this.saveSupplierLoading = true;
            let res = await SaveSupplierOrder(this.sOrderParams);
            this.saveSupplierLoading = false;
            if (res.status === 200 && res.data.code == 0) {
                let data = res.data;
                if (data.code == 0) {
                    this.sOrderParams.orderId = data.data;
                    this.aOrderParams.supplierOrderId = data.data;
                    this.showSupplierOrderInfo = true;
                    this.params.supplierOrderId = data.data;
                    this.getSupplierOrderInfo();
                }
            }
        },
        async getSupplierOrderInfo() {
            let param = {
                orderId: this.sOrderParams.orderId
            };
            let res = await SupplierOrderInfo(param);
            if (res.status === 200 && res.data.code == 0) {
                let data = res.data;
                if (data.code == 0) {
                    let order = data.data;
                    this.supplierOrderInfo = order;
                    let {
                        cycle_explain,
                        start_time,
                        end_time,
                        order_name,
                        game_logo,
                        id
                    } = order;
                    this.sOrderParams.orderName = order_name;
                    this.sOrderParams.supplierOrderId = id;
                    this.sOrderParams.cycleExplain = cycle_explain;
                    this.sOrderParams.dateVal = [start_time, end_time];
                    this.sOrderParams.startTime = start_time;
                    this.sOrderParams.endTime = end_time;
                    this.showSupplierOrderInfo = true;
                    this.$nextTick(() => {
                        this.demandInfo.logoUrl = game_logo;
                    });
                }
            }
        }
    },
    computed: {
        pickerOptions() {
            let self = this;
            return {
                disabledDate(time) {
                    return (
                        new Date(time).getTime() >
                            new Date(self.demandInfo.end_time).getTime() ||
                        new Date(time).getTime() <
                            new Date(self.demandInfo.start_time).getTime() -
                                24 * 24 * 60 * 1000
                    );
                }
            };
        },
        authorOderPickerOptions() {
            let self = this;
            return {
                disabledDate(time) {
                    return (
                        new Date(time).getTime() >
                            new Date(
                                self.supplierOrderInfo.end_time
                            ).getTime() ||
                        new Date(time).getTime() <
                            new Date(
                                self.supplierOrderInfo.start_time
                            ).getTime() -
                                24 * 24 * 60 * 1000
                    );
                }
            };
        },
        getBudget() {
            let [videoPrice, articlePrice, paintingPrice, novelPrice] = [
                400,
                150,
                400,
                250
            ];
            let {
                videoNum,
                textNum,
                paintingNum,
                novelNum
            } = this.aOrderParams;
            videoNum = parseInt(videoNum) > 0 ? parseInt(videoNum) : 0;
            textNum = parseInt(textNum) > 0 ? parseInt(textNum) : 0;
            novelNum = parseInt(novelNum) > 0 ? parseInt(novelNum) : 0;
            paintingNum = parseInt(paintingNum) > 0 ? parseInt(paintingNum) : 0;
            let num =
                videoNum * videoPrice +
                textNum * articlePrice +
                paintingPrice * paintingNum +
                novelNum * novelPrice;
            return num;
        },
        getTeamLeader() {
            let leader = "";
            this.teamList.filter(team => {
                if (team.id == this.aOrderParams.teamId) {
                    leader = team.leader;
                }
            });
            return leader;
        }
    }
};
</script>

